import type { CommonProps } from '../../types';
import { EventCompactCardList } from './event-compact-card-list';
import { EventCompactCardItem } from './event-compact-card-item';
import { ReactNode, type JSX } from 'react';

export interface EventCompactCardProps extends CommonProps {
    children: ReactNode;
}

const EventCompactCard = ({
    className,
    children,
}: EventCompactCardProps): JSX.Element => {
    return <div className={className}>{children}</div>;
};

EventCompactCard.List = EventCompactCardList;
EventCompactCard.Item = EventCompactCardItem;

export { EventCompactCard };
